<template>
  <div id="input-code">
      <h1>输入验证码</h1>
      <p>验证码已发送至：<span>{{ (isPhoneRegist ? '+' + this.area : '') + ' ' + (this.form ? this.form.phone : '-') }}</span></p>
      <div class="vcode" id='vertifycode'>
        <input v-model="code" type="tel" maxlength='6' ref='code' class='code' id='code' @focus="focus = true" @blur="focus = false" :disabled="disabled" />
        <div class="labels">
            <label v-for="(item, index) in length" :key="index" v-text="arrCode[index]" :class='{ active: focus === true && index === currentIndex }' class='label' for="code" />
        </div>
      </div>
      <div class="send-btn" :disabled="ifSended" :class="ifSended ? 'sended' : 'active'" @click="sendCode">{{ ifSended ? `${countDown}s后重新获取` : '重新获取' }}</div>
      <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
      </div>
      <div v-show="!isPhoneRegist" class="tip" title="请仔细核对您的邮箱地址是否正确，或前往广告邮件、垃圾邮件中查看。" @click="showPop">收不到邮箱验证码？
          <div v-show="popShow" class="popover">请仔细核对您的邮箱地址是否正确，或前往广告邮件、垃圾邮件中查看</div>
      </div>
      <jgz-loading :loading-show='showLoading'></jgz-loading>
      <img class="corner" src="@/assets/fixed-invitation/corner.png" alt="">
  </div>
</template>

<script>
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'InputCode',
    data() {
        return {
            ifSended: false,
            countDownFunc: null,
            countDown: 60,
            length: 6,
            // currentIndex: 0,
            code: '',
            focus: false,
            // arrCode: [],
            disabled: false,
            alertShow: false,
            message: '短信验证码有误',
            showLoading: false,
            form: { phone: '' },
            area: '86',
            isPhoneRegist: false,
            popShow: false
        }
    },
    components: {
        JgzLoading,
    },
    computed: {
        arrCode() {
            return this.code.split('')
        },
        currentIndex() {
            return this.code.length
        }
    },
    watch: {
        code(newVal, oldVal) {
            let self = this
            this.code = newVal.replace(/[^\d]/g, '')
            if(newVal.length >= 6) {
                // this.disabled = true
                this.$refs.code.blur()
                setTimeout(() => {
                    console.log('提交'+this.code)
                    this.goSuccess()
                }, 500)
            }
        }
    },
    mounted() {
        this.form = this.$route.params.form
        this.area = this.$route.params.area
        this.isPhoneRegist = this.$route.params.tag
        this.$refs.code.focus()
        this.sendCode()
    },
    methods: {
        showPop() {
            this.popShow = !this.popShow
        },
        sendCode() {
            if(this.ifSended) {
                return
            }
            this.ifSended = true
            const params = this.form ? (this.isPhoneRegist ? { mobile: this.area + this.form.phone, useFor: 'register', scope: 'JGZ' } : { email: this.form.phone, useFor: 'register', scope: 'JGZ' }) : ''
            this.$MyAxios.post(`/api/accounts/verificationCode`, params, 
            true,
            response => {
                if(response.code === 1) {
                    this.countDownFunc = setInterval(() => {
                        if (this.countDown > 1) {
                            this.countDown--
                        } else {
                            this.ifSended = false
                            this.countDown = 60
                            clearInterval(this.countDownFunc)
                            this.countDownFunc = null
                        }
                    }, 1000)
                }
            }, error => {
                this.alertShow = true
                this.message = error
                setTimeout(() => {
                    this.alertShow = false
                }, 4000);
                this.countDownFunc = setInterval(() => {
                    if (this.countDown > 1) {
                        this.countDown--
                    } else {
                        this.ifSended = false
                        this.countDown = 60
                        clearInterval(this.countDownFunc)
                        this.countDownFunc = null
                    }
                }, 1000)
            })
            
            
        },
        register() {
            this.showLoading = false;
            let params = {
                password: this.form.password,
                code: this.code,
                inviteCode: this.form.inviteCode,
                regInviteCode: this.form.registCode,
                scope: 'JGZ',
                roles: ''
            }
            if(this.isPhoneRegist) {
                params['mobile'] = this.area + this.form.phone
            } else {
                params['email'] = this.form.phone
            }
            this.$MyAxios.post(`/exact/register`, params, 
            false,
            response => {
                // debugger
                if(response.code === 1) {
                    this.showLoading = false;
                    this.$router.push('/fixed-invitation-success')
                }else {
                    this.alertShow = true
                    this.message = error
                    setTimeout(() => {
                        this.alertShow = false
                    }, 4000);
                }
            }, error => {
                this.alertShow = true
                this.message = error
                setTimeout(() => {
                    this.alertShow = false
                }, 4000);
            })
        },
        goSuccess() {
            this.register()
        }
    }
}
</script>

<style lang='less'>
#input-code {
    background: #ffffff;
    height: 100vh;
    padding: 60px 60px 0 60px;
    h1 {
        height: 70px;
        line-height: 70px;
        font-size: 50px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #33333a;
    }
    p {
        color: #9598A6;
        font-size: 30px;
        font-weight: 400;
        margin-bottom: 102px;
        span {
            color: #FFA41F;
        }
    }
    .send-btn {
        height: 42px;
        width: 210px;
        margin: 0 auto;
        margin-bottom: 60px;
        font-size: 30px;
        &.sended {
            color: #9598A6;
        }
        &.active {
            color: #FFA41F;
        }
    }
    @keyframes animate {
        100% {
            opacity: 0;
        }
    }
    .container {
        padding: 5%;
    }
    .vcode {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin-bottom: 50px;
    }
    .code {
        width: 100%;
        padding: 0;
        height: 60px;
        font-size: 35px;
        overflow: hidden;
        border: none;
        outline: none;
        opacity: 0;
        margin-left: -175vw; // ios上透明度为0时依然有光标
        -webkit-tap-highlight-color: transparent;
    }
    .labels {
        display: flex;
        display: -webkit-flex;
        width: 100%;
        height: 88px;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        margin-top: -60px;
        -webkit-tap-highlight-color: transparent;// 解决ios点击灰色阴影的问题
    }
    .label {
        height: 88px;
        width: 88px;
        border: solid 2px #E1E2E6;
        border-radius: 8px;
        float: left;
        color: #33333A;
        font-size: 36px;
        line-height: 88px;
        text-align: center;
        padding-bottom: 10px;
        &.active:after { // 伪类实现光标效果
            content: ' ';
            display: inline-block;
            height: 100%;
            width: 2px;
            background: #313131;
            animation: .8s animate infinite;
        }
    }
    .tip {
        color: #9598A6;
        font-size: 28px;
        line-height: 40px;
        text-align: center;
        position: relative;
        .popover {
            height: 156px;
            width: 480px;
            border-radius: 8px;
            box-shadow: 0px 6px 20px 0px rgba(204,206,217,0.30);
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 60px;
            background: #ffffff;
            color: #33333A;
            font-size: 28px;
            line-height: 42px;
            padding: 20px;
        }
    }
    .corner {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 340px;
        height: 340px;
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-50%);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
</style>